var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgQuestionMark16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#questionMark16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.999 14.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.862 10.94c0 .266.096.488.286.666.19.174.432.26.724.26.304 0 .552-.086.742-.26.19-.178.286-.4.286-.666 0-.276-.095-.5-.286-.673-.19-.178-.438-.267-.742-.267-.292 0-.533.089-.724.267a.869.869 0 0 0-.286.673ZM5.301 6.333h1.32c0-.195.028-.375.083-.54.059-.17.144-.317.254-.444.114-.127.256-.225.425-.292.173-.072.372-.108.597-.108.228 0 .442.04.64.12.204.077.367.201.49.375.122.173.184.398.184.673 0 .317-.087.569-.26.755a5.564 5.564 0 0 1-.705.616c-.225.16-.428.336-.61.527-.182.19-.323.404-.425.64-.101.238-.146.51-.133.82l.006.025h1.308v.083c0-.242.032-.436.095-.584.068-.153.176-.295.324-.426.152-.13.349-.29.59-.476.203-.156.4-.324.59-.501.19-.178.347-.392.47-.641.123-.25.184-.555.184-.914 0-.504-.127-.92-.38-1.251a2.219 2.219 0 0 0-.985-.743A3.44 3.44 0 0 0 8.056 3.8c-.334 0-.667.044-.997.133-.326.089-.624.23-.895.425a2.038 2.038 0 0 0-.635.781c-.156.326-.232.724-.228 1.194Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "questionMark16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
});
SvgQuestionMark16.displayName = "SvgQuestionMark16";
export default SvgQuestionMark16;